<template lang="pug">
  //- style {{ ci }}
  #app(:style="ci")
    .error.h-screen(v-if="! initialized && error")
      Error(:code="error.code || 500" :message="error.message")
    .initializing.flex(v-else-if="! initialized")
      Spinner(:size="16" :thickness="3")
    template(v-else)
      Sidebar(ref="sidebar" @mounted="init")
      //- .full-page-loading(v-if="! loaded")
      //-   Spinner(:size="16" :thickness="3")
      .main-grid(ref="panel")
        Header
          template(v-slot:main-menu)
            .main-menu-wrapper
              Menu#main-menu.navbar.container.mx-auto.px-4(k="main-menu" :max-depth="2")
          template(v-slot:breadcrumb)
            BreadcrumbNav(:title="crumb")
        main
          transition(name="slide-fade-inner" mode="out-in" :duration="300")
            Error(v-if="loaded && error" :code="error.code || 500" :message="error.message")
            router-view(v-else-if="loaded" :key="$route.path")
        //- .temp
        //-   input(type="color" v-model="primary")
        Footer
    portal-target(name="modals" transition="modal")
    .notification-wrapper
      Message(
        v-for="message in messages"
        :key="message.id"
        :content="message"
      )
</template>

<script>
import Slideout from 'slideout';

import BreadcrumbNav from '@/components/BreadcrumbNav';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import Menu from '@/components/Menu';
import Footer from '@/components/Footer.vue';
import Message from '@/components/Message';

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
        slideout: undefined,
        primary: '#7BA745',
        secondary: '#e4e3e8',
        header: '#000000',
        baseText: '#3c3d3b',      
        hpBackground: '#ffffff',
        
        sidebarMenuLink: '#ffffff',
        sidebarMenuLinkHover: '#3c3d3b',

        descTextColor: '#3c3d3b',
        descBgGreen: '#F0F5EA',
        descBgGray: '#E0DDDD',
        descBgWhite: '#ffffff'
    };
  },
  components: {
    // Loading,
    // HeaderMenu,
    BreadcrumbNav,
    Sidebar,
    Header,
    Menu,
    Footer,
    Message
  },
  watch: {
    sidebar(value) {
      if (this.slideout && value === true && this.slideout.isOpen() === false)
        setTimeout(() => this.slideout.open(), 150);
      else if (this.slideout && value === false && this.slideout.isOpen() === true) this.slideout.close();
    }
  },
  computed: {
    crumb() {
      return this.product?.name;
    },
    ci() {

      const primary = this.getHSL(this.primary);
      const secondary = this.getHSL(this.secondary);

      /* eslint-disable */
      return {
        // Base Values
        '--primary-color-h': primary.h,
        '--primary-color-s': `${primary.s}%`,
        '--primary-color-l': `${primary.l}%`,

        '--secondary-color-h': secondary.h,
        '--secondary-color-s': `${secondary.s}%`,
        '--secondary-color-l': `${secondary.l}%`,

        '--color-base-text': this.baseText,
        '--color-hp-bg': this.hpBackground,
        '--color-link-sidebar-menu': this.sidebarMenuLink,
        '--color-link-hover-sidebar-menu': this.sidebarMenuLinkHover,

        '--color-descTextColor': this.descTextColor,
        '--color-descBgGreen': this.descBgGreen,
        '--color-descBgWhite': this.descBgWhite,
        '--color-descBgGray': this.descBgGray,

        '--contrastThreshold': '60%',

        // Calculations Based on Lightness
        '--lightnessTransform': '10%',
        '--darknessTransform': '15%',

        '--primary-color-light-l': 'calc(var(--primary-color-l) + var(--lightnessTransform))',
        '--primary-color-dark-l': 'calc(var(--primary-color-l) - var(--darknessTransform))',

        '--secondary-color-light-l': 'calc(var(--secondary-color-l) + var(--lightnessTransform))',
        '--secondary-color-dark-l': 'calc(var(--secondary-color-l) - var(--darknessTransform))',

        '--color-primary': 'hsl(var(--primary-color-h), var(--primary-color-s), var(--primary-color-l))',
        '--color-secondary': 'hsl(var(--secondary-color-h), var(--secondary-color-s), var(--secondary-color-l))',

        '--color-primary-dark': 'hsl(var(--primary-color-h), var(--primary-color-s), var(--primary-color-dark-l))',
        '--color-secondary-dark':
          'hsl(var(--secondary-color-h), var(--secondary-color-s), var(--secondary-color-dark-l))',

        '--color-primary-light': 'hsl(var(--primary-color-h), var(--primary-color-s), var(--primary-color-light-l))',
        '--color-secondary-light':
          'hsl(var(--secondary-color-h), var(--secondary-color-s), var(--secondary-color-light-l))',

        // Calculations Based on Hue
        '--color-primary-complement':
          'hsl(calc(var(--primary-color-h) + 180), var(--primary-color-s), var(--primary-color-l))',
        '--color-primary-triad-1':
          'hsl(calc(var(--primary-color-h) + 120), var(--primary-color-s), var(--primary-color-l))',
        '--color-primary-triad-2':
          'hsl(calc(var(--primary-color-h) - 120), var(--primary-color-s), var(--primary-color-l))',

        '--color-secondary-complement':
          'hsl(calc(var(--secondary-color-h) + 180), var(--secondary-color-s), var(--secondary-color-l))',
        '--color-secondary-triad-1':
          'hsl(calc(var(--secondary-color-h) + 120), var(--secondary-color-s), var(--secondary-color-l))',
        '--color-secondary-triad-2':
          'hsl(calc(var(--secondary-color-h) - 120), var(--secondary-color-s), var(--secondary-color-l))'
      };
      /* eslint-enable */
    },
    ...mapGetters({
      initialized: 'initialized',
      loaded: 'loaded',
      sidebar: 'sidebar',
      messages: 'message/list',
      error: 'error',
      product: 'shop/product'
    })
  },
  methods: {
    init() {
      this.slideout = new Slideout({
        panel: this.$refs.panel,
        menu: this.$refs.sidebar.$el,
        padding: 256,
        tolerance: 70
        // touch: false,
      });

      this.slideout.on('open', () => this.updateSidebarVisibility(true));
      this.slideout.on('close', () => this.updateSidebarVisibility(false));

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1088) this.updateSidebarVisibility(false);
      });
    },
    getHSL(HEX) {
      // Convert hex to RGB first
      let r = 0,
        g = 0,
        b = 0;

      if (HEX.length == 4) {
        r = '0x' + HEX[1] + HEX[1];
        g = '0x' + HEX[2] + HEX[2];
        b = '0x' + HEX[3] + HEX[3];
      } else if (HEX.length == 7) {
        r = '0x' + HEX[1] + HEX[2];
        g = '0x' + HEX[3] + HEX[4];
        b = '0x' + HEX[5] + HEX[6];
      }

      // Then to HSL
      r /= 255;
      g /= 255;
      b /= 255;

      let cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

      if (delta == 0) h = 0;
      else if (cmax == r) h = ((g - b) / delta) % 6;
      else if (cmax == g) h = (b - r) / delta + 2;
      else h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      if (h < 0) h += 360;

      l = (cmax + cmin) / 2;
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      return { h, s, l };
    },
    ...mapMutations({
      updateSidebarVisibility: 'updateSidebarVisibility'
    })
  },
  mounted() {
    // this.$Progress.finish()

    window.addEventListener('click', event => {
      // ensure we use the link, in case the click has been received by a subelement
      let { target } = event;
      while (target && target.tagName !== 'A') target = target.parentNode;

      // handle only links that do not reference external resources
      if (
        target &&
        target.href &&
        target.matches("a:not([href^='tel:'])") &&
        target.matches("a:not([href^='mailto:'])") &&
        (target.matches(`a[href*='${window.location.origin}']`) || target.matches("a:not([href*='://'])"))
      ) {
        // some sanity checks taken from vue-router:
        // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
        const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event;

        // don't handle with control keys
        if (metaKey || altKey || ctrlKey || shiftKey) return;

        // don't handle when preventDefault called
        if (defaultPrevented) return;

        // don't handle right clicks
        if (button !== undefined && button !== 0) return;

        // don't handle if `target="_blank"`
        if (target && target.getAttribute) {
          const linkTarget = target.getAttribute('target');
          if (/\b_blank\b/i.test(linkTarget)) return;
        }

        // don't handle same page links/anchors
        const url = new URL(target.href);
        const to = url.pathname;
        if (window.location.pathname !== to && event.preventDefault) {
          event.preventDefault();
          this.$router.push(to);
        }
      }
    });
  }
};
</script>

<style lang="sass" nolang="scss">
@import '~@/assets/sass/main'

#app
  touch-action: pan-x pan-y
  > .initializing
    min-height: 100vh

.full-page-loading
  position: fixed
  width: 100%
  height: 100vh

.main-grid
  background: var(--color-hp-bg)
  min-height: 100vh
  display: grid
  grid-template-rows: max-content auto max-content
  grid-template-columns: 100%
  > main
    display: flex
    > div:not(.container)
      min-width: 100%

.notification-wrapper
  position: fixed
  left: 10px
  z-index: 999
  top: 20px
  @screen lg
    top: unset
    bottom: 2rem
    left: 2rem
  .notification + .notification
    margin-top: 1rem

.main-menu-wrapper
  display: none
  color: #fff
  background-color: theme('colors.gray.700')
  @screen md
    display: block

  #main-menu
    ul.tree-menu > li
      &.hover > .tree-item a,
      &.active > .tree-item a
        color: var(--color-primary)
        border-color: transparent
        background: $backgroundColor
      > .tree-item a
        @apply bg-gray-600
        color: inherit
        transition: color .15s ease, border-color .3s ease, background-color .3s ease
</style>
